import React, { useEffect } from 'react';
import './App.css';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Home from './components/Home';
import About from './components/About';
import Publications from './components/Publications';
import ContactUs from './components/ContactUs';
import Executives from './components/Executives';
import Testimony from './components/Testimony';
import NotFound from './components/NotFound';
import Panel from './admin/Panel';
import Messages from './admin/Messages';
import Events from './admin/Events';
import NewExecutive from './admin/NewExecutive';
import NewPublication from './admin/NewPublications';
import NewTestimonies from './admin/NewTestimonies';
import Aos from 'aos';
import 'aos/dist/aos.css'
import NewsLetter from './admin/NewsLetter';
import Assessment from './components/Assessment';
import UploadResult from './components/UploadResult';
import Recruitment from './admin/Recruitment';

function App() {
  useEffect(()=>{
    Aos.init({duration: 2000})
  }, [])
  return (
    <BrowserRouter>
      <Routes>
        <Route 
          path='/'
          element={<Home />}
        />
        <Route 
          path='/about'
          element={<About />}
        />
        <Route 
          path='/publications'
          element={<Publications />}
        />
        <Route 
          path='/executives'
          element={<Executives  />}
        />
        <Route 
          path='/testimony'
          element={<Testimony />}
        />
        <Route 
          path='/contact'
          element={<ContactUs />}
        />
        <Route 
          path='*'
          element={<NotFound />}
        />
        <Route path='/panel' element={<Panel />} >
          <Route
            path='/panel'
            element={<Recruitment />}
          />
          <Route
            path='/panel/messages'
            element={<Messages />}
          />
          <Route 
            path='/panel/events'
            element={<Events />}
          />
          <Route 
            path='/panel/executive'
            element={<NewExecutive />}
          />
          <Route 
            path='/panel/publications'
            element={<NewPublication />}
          />
          <Route 
            path='/panel/testimonies'
            element={<NewTestimonies />}
          />
          <Route 
            path='/panel/newsletter'
            element={<NewsLetter />}
          />
        </Route>
        <Route path='/assessment' element={<Assessment />} />
        <Route path='/result-upload' element={<UploadResult />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
